import { c as _c } from "react/compiler-runtime";
import { css, Global } from '@emotion/react';
import { ClarityAdvisorImportSection } from '@src/components/sco/Advisors/sections/ClarityAdvisorImportSection';
import { AppLayout } from '@src/components/sco/AppLayout';
import { ScoSiteNavBar } from '@src/components/sco/nav/ScoSiteNavBar';
import { SSRGate } from '@src/components/sco/utilities/SSRGate';
const hubspotHideStyles = css`
  div#hubspot-messages-iframe-container {
    display: none !important;
  }
`;

/** Public chrome — do not use AdvisorsLayout (that dumps guests onto the marketing landing). */
export const ClarityAdvisorImportLayout = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Global styles={hubspotHideStyles} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ScoSiteNavBar />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SSRGate disableSSR={true}>{t0}<AppLayout header={t1} id="clarity-advisor-import" panels={[{
        id: "clarity-advisor-import-main",
        children: <ClarityAdvisorImportSection />,
        containerProps: {
          bgColor: "colorPalette.panel"
        },
        innerBoxProps: {
          height: "auto",
          minHeight: "full",
          overflowX: "hidden",
          overflowY: "visible"
        }
      }]} /></SSRGate>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};